import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PageBase, ObjectTypeClassInfo, PhotoAngleInfo, SafetyCheckQuestionInfo } from 't4core';
import { CreateObjectTypeClassDialog } from '../../dialogs/CreateObjectTypeClassDialog/CreateObjectTypeClassDialog';
import { ObjectTypeClassAttributesInfo } from '../../../../../projects/t4core/src/public-api';
import { Router } from '@angular/router';
import { PhotoAngleDialog } from '../../dialogs/PhotoAngleDialog/PhotoAngleDialog';
import { SafetyCheckQuestionDialog } from '../../dialogs/SafetyCheckQuestionDialog/SafetyCheckQuestionDialog';

@Component({
  styleUrls: ['./ObjectTypeClass.css'],
  selector: 'ObjectTypeClass',
  templateUrl: './ObjectTypeClass.html',
})
export class ObjectTypeClass extends PageBase implements OnInit {

  public objectTypeClasses: ObjectTypeClassInfo[] = [];
  public allObjectTypeClassses: ObjectTypeClassInfo[] = [];
  public PhotoAngles: PhotoAngleInfo[];
  public SafetyCheckQuestions: SafetyCheckQuestionInfo[];
  public ineheritedObjectTypeClasses: ObjectTypeClassInfo[];
  constructor(el: ElementRef, private router: Router) {
    super(el, "Settings");
  }
  async ngOnInit() {
    await this.getObjectTypeClass();
    //await this.getAllPhotoAngles();
    //await this.getAllSafetyCheckQuestions();
  }

  public async deleteTypeClass(typeClass: ObjectTypeClassInfo) {
    if (typeClass == null) return;
    var token = this.UI.beginLoading("T4.Settings.ObjectTypeClass.msgDeleting", "Deleting Object Type Class", null);
    var res = await this.Api.delete<boolean>("Settings/DeleteObjectTypeClass", { classId: typeClass.Id });
    await this.getObjectTypeClass();
    this.UI.loaderCompleted(token);
  }
  public async getObjectTypeClass() {
    var token = this.UI.beginLoading("T4.Settings.ObjectTypeClass.msgLoading", "Loading Object Type Class", null);
    var res = await this.Api.get<ObjectTypeClassInfo[][]>("Settings/GetAllObjectTypeClasses");
    this.allObjectTypeClassses = [...res[0], ...res[1]];
    this.objectTypeClasses = res[0];
    var ineheritedClasses = res[1];

    var inheritedTypeClasses: ObjectTypeClassInfo[] = [];

    const overriddenIds = this.allObjectTypeClassses.filter(c => c.OverridesClassId).map(c => c.OverridesClassId);

    this.ineheritedObjectTypeClasses = ineheritedClasses.map(x => ({
      ...x,
      isOverridden: overriddenIds.includes(x.Id)
    }));
    this.UI.loaderCompleted(token);
  }

  public async getAllPhotoAngles() {
    var token = this.UI.beginLoading("T4.Settings.ObjectTypeClass.msgLoadingPhotoAngles", "Loading Photo angles Class", null);
    this.PhotoAngles = await this.Api.get<PhotoAngleInfo[]>("Rental/GetAllPhotoAngles");
    this.UI.loaderCompleted(token);
  }
    public async getAllSafetyCheckQuestions() {
      var token = this.UI.beginLoading("T4.Settings.ObjectTypeClass.msgLoadingSafetyCheckQuestions", "Loading Safety Check Questions", null);
      this.SafetyCheckQuestions = await this.Api.get<SafetyCheckQuestionInfo[]>("Settings/GetSafetyCheckQuestions");
      this.UI.loaderCompleted(token);
    }


  public async openObjectTypeClassDetails(typeClass: ObjectTypeClassInfo) {
    this.router.navigateByUrl("/Settings/ObjectTypeClassDetails/" + typeClass.Id);
  }

  public async openObjectTypeClass(typeClass: ObjectTypeClassInfo = null, editable: boolean = true) {
    var res = await this.Dialog.open(CreateObjectTypeClassDialog, { width: '850px', data: { objectTypeClass: typeClass, editable: editable } }).afterClosed().toPromise();
    var token = this.UI.beginLoading("T4.Settings.ObjectTypeClass.msgUpdating", "Updating Object Type class ", null);
    await this.getObjectTypeClass();
    this.UI.loaderCompleted(token);
  }

  public getClassNameById(id: number) {
    if (id == null || id == undefined) return;
    const typeClass = this.allObjectTypeClassses.find(tc => tc.Id == id);
    return typeClass ? typeClass.Name : "unkown";
  }

}
